import { createFileRoute } from "@tanstack/react-router";
import BokforingUmea from "@/pages/BokforingUmea";
import {
  buildBreadcrumbSchema, getBreadcrumbTrail,
  buildPageSchema,
  buildSeoHead,
  buildServiceSchema,
  publicPageSeo,
} from "@/data/seo";

export const Route = createFileRoute("/bokforing-umea")({
  head: () =>
    buildSeoHead(
      publicPageSeo.bokforingUmea,
      [
        buildPageSchema(publicPageSeo.bokforingUmea, "WebPage"),
        buildServiceSchema(publicPageSeo.bokforingUmea, "Löpande bokföring i Umeå", [
          "Digital bokföring",
          "Avstämningar",
          "Rapportering",
          "Proaktiv rådgivning",
        ]),
        buildBreadcrumbSchema(getBreadcrumbTrail("/bokforing-umea") ?? []),
      ],
    ),
  component: BokforingUmea,
});
